// import React from 'react'

// const PurchaseApprovalPending = () => {
//   return (
//     <div>PurchaseApprovalPending</div>
//   )
// }

// export default PurchaseApprovalPending



import { Grid } from "@mui/material";
import CustomTable from "../../../../Components/Table/CustomTable";

import { useDispatch, useSelector } from "react-redux";
import { setHeaderName } from "../../../../ReduxStore/Slices/headerSlice";
// import TableDataViewModal from "../Modal/TableDataViewModal";
import actions from "../../../../ReduxStore/actions";
import TableDataViewModal from "../../../Operator/Modal/TableDataViewModal";
import ShemeApprovalModalView from "./Modal/ReferralsShemeApprovalModalView";
import ReferralsShemeApprovalModalView from "./Modal/ReferralsShemeApprovalModalView";
// import { setHeaderName } from './headerSlice';

const ReferralsShemePendingApproval = ({ setHeaderTitleName }) => {
//   const sessionOperator_id = sessionStorage.getItem("sessionOperator_id");
//   const UserRole = sessionStorage.getItem("UserRole");

//    const customerId = useSelector((state) => state.customer);

//    console.log(customerId,"customerIdcustomerIdcustomerIdcustomerId");
   

//   const { managementRegisterForCustomer } = useSelector(
//     (state) => state?.managementRegisterForCustomer
//   );
//   const dispatch = useDispatch();
//   const { getCustomersByCreator } = useSelector(
//     (state) => state?.getCustomersByCreator
//   );

// console.log(getCustomersByCreator,"getCustomersByCreatorgetCustomersByCreator")

//   useEffect(() => {
//     const data1 = {
//       data: {
//         createdByUserId: sessionOperator_id,
//         createdByUserRole: UserRole,
//       },
//       method: "get",
//       apiName: "getCustomersByCreator",
//     };

//     dispatch(actions.GETCUSTOMERSBYCREATOR(data1));
//   }, [managementRegisterForCustomer]);

//   const [rowTableData, setRowTableData] = useState([
//     {
//       Name: "--",
//       CustomerId:"--",
//       Email: "--",
//       MobileNumber: "--",
//       UserType: "--",
//       Status: "--",
//     },
//   ]);
//   console.log(rowTableData, "rowTableDatarowTableData");
//   useEffect(() => {
//     const tempArr = [];
//     getCustomersByCreator?.data?.map((data, index) => {
//       return tempArr.push({
//         Name: `${data?.first_name} ${data?.last_name}` || "--",
//         customer_id:data?.customer_id || "--",
//         Email: data?.email || "--",
//         MobileNumber: data?.phone || "--",
//         UserType: data?.role ? data?.role : "--",
//         Status:
//           data?.approval_status === "pending"
//             ? "Pending"
//             : data?.approval_status === "approved"
//             ? "Approved"
//             : "Unknown" || "--", // Add a default case if needed
            
//       });   
//     });
//     setRowTableData(tempArr);
//   }, [dispatch, getCustomersByCreator]);

  
//   useEffect(() => {
//     // setHeaderTitleName("User Registration")
//     dispatch(setHeaderName("User Registration"));
//   }, []);
const tableData = [
  { UserType:"User",title: 'Diamond Referral', startDate:"15/Mar/2025", endDate: "15/Mar/2025",reap:"13.8g", Status: "Pending" },
  { UserType:"User",title: 'Ruby Referral', startDate:"15/Mar/2025", endDate: "15/Mar/2025",reap:"13.8g",Status: "Pending" },
  { UserType:"Financial Consultant",title: 'Diamond Referral', endDate:"15/Mar/2025", startDate: "15/Mar/2025",reap:"13.8g",Status: "Pending" },


];
const tableHeadData = ['S.No', 'User Type', "Title",  'start Date', "End Date","Reap", "Status"];


  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sx={{ width: "100px" }}>
        <CustomTable
          tableData={tableData}
          // title="User List"
          // title="Referrals Scheme Approval"
          title="Scheme Approval-Referrals Scheme"
          
          
          tableHeadData={tableHeadData}
        //   modalName={UserCreateByOperatorModal}
          allShowModal="allShowModal"
          modalVeiwName={ReferralsShemeApprovalModalView}
        //   notModalTable="notModalTable"
        //   tableEdit="tableEdit"
          tableView="tableView"
          modalViewHeadingName="Scheme Approval"
          modalHeadingName="Create User"
          dataCreate="dataCreate"
          IsShowRejectApproveButton="IsShowRejectApproveButton"
        />
      </Grid>
    </Grid>
  );
};

export default ReferralsShemePendingApproval;
